import React, { useEffect, useState } from 'react';

interface BotanicalDividerProps {
  position: 'top' | 'bottom';
  className?: string;
}

const BotanicalDivider: React.FC<BotanicalDividerProps> = ({ position, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    
    const element = document.getElementById(`botanical-divider-${position}`);
    if (element) observer.observe(element);
    
    return () => {
      if (element) observer.unobserve(element);
    };
  }, [position]);

  return (
    <div 
      id={`botanical-divider-${position}`}
      className={`w-full flex items-center justify-center py-8 ${className}`}
    >
      <div className="w-full max-w-4xl px-4 flex items-center justify-center">
        {/* Línea izquierda con círculo */}
        <div className="flex-1 flex items-center">
          <div className="flex-1 h-px bg-sage/30"></div>
          <div className="w-1.5 h-1.5 bg-[#cdd5c4] rounded-full mx-2"></div>
        </div>
        
        {/* Composición botánica central */}
        <div 
          className={`relative w-24 md:w-36 h-24 md:h-36 transition-all duration-1000 transform ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
          }`}
        >
          {/* Imagen principal - diferente según la posición */}
          <div className="absolute inset-0 flex items-center justify-center">
            <img 
              src={position === 'top' ? '/lovable-uploads/21.png' : '/lovable-uploads/22.png'} 
              alt="" 
              className="w-full h-full object-contain"
            />
          </div>
           </div>
        
        {/* Línea derecha con círculo */}
        <div className="flex-1 flex items-center">
          <div className="w-1.5 h-1.5 bg-[#cdd5c4] rounded-full mx-2"></div>
          <div className="flex-1 h-px bg-sage/30"></div>
        </div>
      </div>
    </div>
  );
};

export default BotanicalDivider; 